(function($) {

  $(document).ready(function() {
    collection.init();
  });

  if ($(".engoj-collection-sidebar").length) {
    History.Adapter.bind(window, 'statechange', function() {
      var State = History.getState();
      if (!collection.fillterClick) {
        collection.filterParams();
        var newurl = collection.filterCreateUrl();
        collection.filterGetContent(newurl);
        collection.resetFilter();
      }
      collection.fillterClick = false;
    });
  }

  var collection = {
    // Cache frequently used selectors
    $body: null,
    $filterBlocks: null,
    debounceTimer: null,
    
    init: function() {
      // Cache DOM elements
      this.$body = $('body');
      this.$filterBlocks = $('.filter-blocks');
      
      /* Collection Filter */
      this.initCollectionFilter();
      /* Collection Show */
      this.initCollectionShow();
      /* Collection Sorting */
      this.initCollectionSorting();
      /* Custom Color Filter */
      this.initCustomColorFilter();
      /* Custom Size Filter */
      this.initCustomSizeFilter();
    },

    // Debounce function to prevent excessive AJAX calls
    debounce: function(func, wait) {
      var self = this;
      return function() {
        var context = this, args = arguments;
        clearTimeout(self.debounceTimer);
        self.debounceTimer = setTimeout(function() {
          func.apply(context, args);
        }, wait || 300);
      };
    },

    /* --------------------------------------------------------- */
    /* Custom Color Filter Handler */
    initCustomColorFilter: function() {
      var self = this;
      var debouncedHandler = this.debounce(function() {
        self.handleColorFilterChange();
      }, 250);
      
      // Handle color filter checkbox changes
      this.$body.on('change', '.filter-color input[type="checkbox"]', function(e) {
        e.preventDefault();
        debouncedHandler();
      });
      
      // Handle color filter link clicks
      this.$body.on('click', '.filter-color a:not(.clear)', function(e) {
        e.preventDefault();
        var $this = $(this);
        $this.toggleClass('active');
        var $checkbox = $this.prev('input[type="checkbox"]');
        if ($checkbox.length) {
          $checkbox.prop('checked', !$checkbox.prop('checked'));
          debouncedHandler();
        }
      });
      
      // Handle color filter clear button
      this.$body.on('click', '.filter-color .clear', function(e) {
        e.preventDefault();
        $('.filter-color input[type="checkbox"]:checked').prop('checked', false);
        $('.filter-color a.active').removeClass('active');
        self.handleColorFilterChange();
      });
    },

    handleColorFilterChange: function() {
      // Remove color filter parameters efficiently
      this.removeFilterParams('filter.v.option.color');
      
      // Build array of selected colors
      var selectedColors = [];
      $('.filter-color input[type="checkbox"]:checked').each(function() {
        selectedColors.push(this.value); // Use native property instead of jQuery
      });
      
      // Add selected colors to queryParams
      if (selectedColors.length > 0) {
        Shopify.queryParams['filter.v.option.color'] = selectedColors;
      }
      
      // Trigger AJAX filter
      this.filterAjaxClick();
    },

    /* --------------------------------------------------------- */
    /* Custom Size Filter Handler */
    initCustomSizeFilter: function() {
      var self = this;
      var debouncedHandler = this.debounce(function() {
        self.handleSizeFilterChange();
      }, 250);
      
      // Handle size filter checkbox changes
      this.$body.on('change', '.filter-size input[type="checkbox"]', function(e) {
        e.preventDefault();
        debouncedHandler();
      });
      
      // Handle size filter link clicks
      this.$body.on('click', '.filter-size a:not(.clear)', function(e) {
        e.preventDefault();
        var $this = $(this);
        $this.toggleClass('active');
        var $checkbox = $this.prev('input[type="checkbox"]');
        if ($checkbox.length) {
          $checkbox.prop('checked', !$checkbox.prop('checked'));
          debouncedHandler();
        }
      });
      
      // Handle size filter clear button
      this.$body.on('click', '.filter-size .clear', function(e) {
        e.preventDefault();
        $('.filter-size input[type="checkbox"]:checked').prop('checked', false);
        $('.filter-size a.active').removeClass('active');
        self.handleSizeFilterChange();
      });
    },

    handleSizeFilterChange: function() {
      // Remove size filter parameters efficiently
      this.removeFilterParams('filter.v.option.size');
      
      // Build array of selected sizes
      var selectedSizes = [];
      $('.filter-size input[type="checkbox"]:checked').each(function() {
        selectedSizes.push(this.value);
      });
      
      // Add selected sizes to queryParams
      if (selectedSizes.length > 0) {
        Shopify.queryParams['filter.v.option.size'] = selectedSizes;
      }
      
      // Trigger AJAX filter
      this.filterAjaxClick();
    },

    // Helper function to remove filter parameters efficiently
    removeFilterParams: function(key) {
      delete Shopify.queryParams[key];
    },

    /* --------------------------------------------------------- */
    /* Categories Filter */
    fillterTagEvents: function() {
      var self = this;
      
      this.$body.on('click', '.filter-tag:not(.filter-color):not(.filter-size) a:not(".clear"), .filter-tag:not(.filter-color):not(.filter-size) label', function(e) {
        e.preventDefault();
        
        var $this = $(this);
        $this.toggleClass('active');
        var selected = $this.text();
        var $dropdown = $this.closest('.dropdown');
        
        if ($dropdown.length) {
          var text1 = "";
          $dropdown.find('.dropdown-label').text($this.hasClass('open') ? text1 : selected);
        }
        
        var $filterTag = $this.closest('.filter-tag');
        var filterType = $filterTag.data('filter-type');
        
        if (!filterType) return;
        
        var currentTags = [];
        var paramValue = Shopify.queryParams['filter.v.option.' + filterType];
        if (paramValue) {
          currentTags = Array.isArray(paramValue) ? paramValue.slice() : [paramValue];
        }

        if (!window.filter_mul_choice && !$this.prev().is(":checked")) {
          var $otherTag = $filterTag.find("input:checked");
          if ($otherTag.length > 0) {
            var tagName = $otherTag.val();
            if (tagName) {
              var tagPos = currentTags.indexOf(tagName);
              if (tagPos >= 0) {
                currentTags.splice(tagPos, 1);
              }
            }
          }
        }

        var tagName = $this.prev().val();
        if (tagName) {
          var tagPos = currentTags.indexOf(tagName);
          if (tagPos >= 0) {
            currentTags.splice(tagPos, 1);
          } else {
            currentTags.push(tagName);
          }
        }
        
        // Update query params
        if (currentTags.length) {
          Shopify.queryParams['filter.v.option.' + filterType] = currentTags;
        } else {
          delete Shopify.queryParams['filter.v.option.' + filterType];
        }
        
        self.filterAjaxClick();
      });
    },

    filterMapClearAll: function() {
      var self = this;
      
      // Clear all filters
      this.$body.on('click', '.refined-widgets a.clear-all', function(e) {
        e.preventDefault();
        
        // Remove all filter parameters efficiently
        var keys = Object.keys(Shopify.queryParams);
        for (var i = keys.length - 1; i >= 0; i--) {
          if (keys[i].indexOf('filter.v.option.') === 0) {
            delete Shopify.queryParams[keys[i]];
          }
        }
        
        delete Shopify.queryParams.constraint;
        delete Shopify.queryParams.q;
        
        self.filterAjaxClick();
      });

      // Clear individual filter group
      this.$body.on('click', '.filter-block .clear, .filter-tag .clear', function(e) {
        e.preventDefault();
        
        var $this = $(this);
        var $filterTag = $this.closest('.filter-tag, .filter-block');
        var filterType = $filterTag.data('filter-type');
        
        // Uncheck all inputs in this filter group
        $filterTag.find("input:checked").prop('checked', false);
        $filterTag.find("a.active").removeClass("active");
        
        // Remove filter type from query params
        if (filterType) {
          delete Shopify.queryParams['filter.v.option.' + filterType];
        }
        
        // Hide clear button
        $this.hide();
        
        self.filterAjaxClick();
      });
    },

    filterMapClear: function() {
      $(".filter-tag").each(function() {
        var $filterTag = $(this);
        var $clearBtn = $filterTag.find(".clear");
        
        $clearBtn.toggle($filterTag.find("input:checked").length > 0);
      });
    },

    filterParams: function() {
      Shopify.queryParams = {};
      
      if (location.search.length) {
        var params = new URLSearchParams(location.search);
        var groupedParams = {};
        
        params.forEach(function(value, key) {
          var decodedKey = decodeURIComponent(key);
          var decodedValue = decodeURIComponent(value);
          
          if (groupedParams[decodedKey]) {
            if (!Array.isArray(groupedParams[decodedKey])) {
              groupedParams[decodedKey] = [groupedParams[decodedKey]];
            }
            groupedParams[decodedKey].push(decodedValue);
          } else {
            groupedParams[decodedKey] = decodedValue;
          }
        });
        
        Shopify.queryParams = groupedParams;
      }
    },

    filterMapEvents: function() {
      this.fillterTagEvents();
    },

    resetFilter: function() {
      $(".filter-custom .active, .filter-links .active").removeClass("active");
      $(".filter-tag input:checked").prop("checked", false);

      // Re-check based on current URL params - optimized loop
      var params = Shopify.queryParams;
      for (var key in params) {
        if (key.indexOf('filter.v.option.') === 0) {
          var values = Array.isArray(params[key]) ? params[key] : [params[key]];
          for (var i = 0; i < values.length; i++) {
            var $input = $('.filter-tag input[value="' + values[i] + '"]');
            $input.prop('checked', true).next('a').addClass('active');
          }
        }
      }

      // Category
      var cat = location.pathname.match(/\/collections\/(.*)(\?)?/);
      if (cat && cat[1]) {
        $(".filter-links a[href='" + cat[0] + "']").addClass("active");
      }
      
      this.filterMapClear();
    },

    filterMapData: function(data) {
      var $data = $(data);
      
      // Use faster replacement methods
      var $currentList = $(".product-collection-grid");
      var $productList = $data.find(".product-collection-grid");
      
      if ($productList.length && $currentList.length) {
        $currentList.replaceWith($productList);
      }

      // Replace paging
      var $currentPagination = $(".pagination");
      if ($currentPagination.length) {
        var $newPagination = $data.find(".pagination");
        if ($newPagination.length) {
          $currentPagination.replaceWith($newPagination);
        }
      }

      // Replace filter blocks
      var $newFilterBlocks = $data.find(".filter-blocks");
      if ($newFilterBlocks.length) {
        $('.filter-blocks').replaceWith($newFilterBlocks);
      }
      
      this.filterMapClear();
    },

    filterCreateUrl: function(baseLink) {
      var params = [];
      var queryParams = Shopify.queryParams;
      
      for (var key in queryParams) {
        if (queryParams.hasOwnProperty(key)) {
          var value = queryParams[key];
          if (Array.isArray(value)) {
            for (var i = 0; i < value.length; i++) {
              params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value[i]));
            }
          } else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
          }
        }
      }
      
      var newQuery = params.join('&');
      
      if (baseLink) {
        return newQuery ? baseLink + "?" + newQuery : baseLink;
      }
      return location.pathname + (newQuery ? "?" + newQuery : "");
    },

    filterAjaxClick: function(baseLink) {
      delete Shopify.queryParams.page;
      var newurl = this.filterCreateUrl(baseLink);
      this.fillterClick = true;
      History.pushState({
        param: Shopify.queryParams
      }, newurl, newurl);
      this.filterGetContent(newurl);
    },

    filterGetContent: function(newurl) {
      var self = this;
      
      $.ajax({
        type: 'GET',
        url: newurl,
        dataType: 'html',
        beforeSend: function() {
          showPopup('.loading');
        },
        success: function(data) {
          self.filterMapData(data);
          self.filterMapClear();
          hidePopup('.loading');
        },
        error: function(xhr, text) {
          hidePopup('.loading');
          try {
            var response = $.parseJSON(xhr.responseText);
            $('.ajax-error-message').text(response.description || 'An error occurred');
          } catch(e) {
            $('.ajax-error-message').text('An error occurred');
          }
          showPopup('.ajax-error-modal');
        }
      });
    },

    initCollectionFilter: function() {
      if ($(".engoj-collection-sidebar").length > 0) {
        this.filterParams();
        this.filterMapEvents();
        this.filterMapClear();
        this.filterMapClearAll();
      }
    },

    /* --------------------------------------------------------- */
    /* Collection Sorting */
    initCollectionSorting: function(e) {
      var self = this;
      
      $(".wrap-filter-sorting li a").on('click', function(e) {
        e.preventDefault();
        var $this = $(this);
        var $parent = $this.parent();
        
        if (!$parent.hasClass("active")) {   
          Shopify.queryParams.sort_by = $this.attr("href");
          self.filterAjaxClick();          

          $(".wrap-filter-sorting li.active").removeClass("active");
          $parent.addClass("active");
        }
        
        var selected = $this.text();
        $this.closest('.filter').find('.dropdown-label').text(selected);
        $this.closest('.dropdown-toggle').removeClass('active');  
      });
    },

    /* --------------------------------------------------------- */
    /* Collection Show */
    initCollectionShow: function() {
      var self = this;
      
      $(".filter-show a").on('click', function(e) {  
        e.preventDefault();
        var $this = $(this);
        var $parent = $this.parent();
        
        if (!$parent.hasClass("active")) {
          var currentPage = $this.attr('href'); 
          var view = $(".button-view a.active").attr("data-mode");
          
          Shopify.queryParams.view = (view == "list") ? "list" + currentPage : currentPage;
          
          self.filterAjaxClick();
          $(".filter-show li.active").removeClass("active");
          $parent.addClass("active");
          $this.closest('.dropdown').find('.dropdown-label').text(currentPage);
          $this.closest('.dropdown-content').removeClass('active');  
        }
      });
    }
  };

})(jQuery);